import type { OrderPrintLogView } from '../../../../../services/orders/orders.service';

export function getKindLabel(kind: OrderPrintLogView['kind']): string {
  if (kind === 'receipt_print') return 'הדפסת חשבון';
  if (kind === 'red_fire') return 'RED - דילוג';
  if (kind === 'reprint') return 'הדפסה חוזרת';
  return 'הדפסת מטבח';
}
